import { Overline } from "@/components/Reveal";
import { motion } from "framer-motion";

export const LegalPage = ({ title, updated, children }) => (
  <section className="relative pt-36 md:pt-44 pb-28 md:pb-40 border-b border-white/5">
    <div className="absolute inset-0 grid-lines opacity-30 pointer-events-none" />
    <div className="relative mx-auto max-w-[820px] px-6 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      >
        <Overline>Documento</Overline>
        <h1 className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter leading-[1.02] mt-6">
          {title}
        </h1>
        {updated && (
          <p className="font-mono text-xs text-neutral-500 mt-5">
            Última atualização: {updated}
          </p>
        )}
      </motion.div>

      <div className="mt-14 space-y-6 text-[15px] md:text-base leading-relaxed text-neutral-400 [&_h2]:font-display [&_h2]:font-bold [&_h2]:text-xl [&_h2]:md:text-2xl [&_h2]:tracking-tight [&_h2]:text-white [&_h2]:mt-12 [&_h2]:mb-1 [&_p]:mt-3 [&_a]:text-white [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-neutral-300 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:space-y-2 [&_ol]:mt-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_ul]:mt-3">
        {children}
      </div>
    </div>
  </section>
);
